var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"faq"},[(_vm.cover)?_c('page-cover',{attrs:{"cover":_vm.cover}}):_vm._e(),_c('FaqPage')],1)}
var staticRenderFns = []

export { render, staticRenderFns }